var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mp-box"},[_c('div',{staticClass:"open-btn",on:{"click":_vm.openMiniPro}},[_vm._v("点击打开小程序")])])
}
var staticRenderFns = []

export { render, staticRenderFns }